import classNames from 'classnames';
import {
    Select as LuffySelect,
    SelectProps as LuffySelectProps,
} from '@baidu/luffy-comp-select';
import {Props} from '@/interface';

export type {SelectValue, SelectOptionObject} from '@baidu/luffy-comp-select';
export {Option} from '@baidu/luffy-comp-select';
import styles from './index.module.scss';

export enum SelectType {
    Normal = 'normal',
    Plain = 'plain',
}

export enum SelectSize {
    XS = 'xs',
    SM = 'sm',
    MD = 'md',
    LG = 'lg',
}

interface SelectProps extends LuffySelectProps, Props{
    allowEmpty?: boolean;
    type?: SelectType;
}

export default function Select(props: SelectProps) {

    const {
        children,
        allowEmpty = false,
        type = SelectType.Normal,
        className, withClear,
        ...selectProps
    } = props;
    const selectClass = classNames(
        type === SelectType.Plain && styles.plain,
        className
    );
    return (
        <LuffySelect withClear={allowEmpty} className={selectClass} {...selectProps}>
            {children}
        </LuffySelect>
    );
}
